const isProduction =  process.env.NODE_ENV === 'production';

console.log(isProduction);

if(!isProduction) {
    setTimeout(() => window.dispatchEvent(new Event('resize')),500);
}



// WEBPACK FOOTER //
// ./scripts/autoload/dev.js